module.exports = __webpack_public_path__ + "img/68_40.d691bbd1.png";